import React from 'react';
//This is for main pages
function EntryCard({ children }) {
  return (
    <div style={{'maxWidth': 80
     + 'rem'}} className="mx-auto pt-8 pb-20">
      <div className="sm:mx-8 sm:border sm:shadow-xl sm:px-8">
        {children} 
      </div>
    </div>
  );
}

export default EntryCard;